export default __webpack_public_path__ + "static/media/Close-Settings.234e9591.png";